import React, {useRef, useState} from "react";
import "./Upload.css";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileImport, faSpinner} from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-bootstrap/Modal';


function Upload({bond, backupApi, restoreApi, onUploadDone}) {
    const [uploadStarted, setUploadStarted] = useState(false);
    const [show, setShow] = useState(false);
    const [uploadFile, setUploadFile] = useState(null);
    const [isFolderValid, setIsFolderValid] = useState(false);
    const uploadFolderRef = useRef("")

    async function startUpload() {
        if (!(uploadFile && uploadFolderRef.current.value)) return;

        if (!/^[a-zA-Z0-9_]+$/.test(uploadFolderRef.current.value)) {
            setIsFolderValid(false);
            return;
        }

        setUploadStarted(true);
        try {
            await restoreApi.upload(uploadFile, uploadFolderRef.current.value);
            setUploadStarted(false);
            onUploadDone(uploadFolderRef.current.value);
            handleClose();
        } catch (e) {
            setUploadStarted(false);
        }
    }

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setUploadFile(null);
        setIsFolderValid(true);
        setShow(true);
    }

    function handleFileSelect(event) {
        const file = event.target.files[0];
        if (file && file.size < 1048576) {
            setUploadFile(file);
        } else {
            if (file) alert("File size should be less than 1MB");
        }
    }


    return (<>
        <Button variant="secondary" onClick={handleShow} className={"w-100 mt-2"}>
            <FontAwesomeIcon icon={faFileImport} className="me-2"/> Upload Backup File
        </Button>

        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            size={"lg"}
            keyboard={false}
            className={"uploadModal"}
        >
            <Modal.Header closeButton>
                <Modal.Title className={"text-center align-middle w-100"}>
                    <FontAwesomeIcon icon={faFileImport} className="me-2"/>
                    Upload Bond <em>.bondbackup </em>File
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="formFile" className="mb-3">
                    <Form.Label>Select <em>.bondbackup</em> file (less than 1MB)</Form.Label>
                    <Form.Control type="file" accept=".bondbackup" onChange={handleFileSelect}
                                  isValid={uploadFile}
                                  isInvalid={uploadFile === null}/>
                    <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">S3 Folder</InputGroup.Text>
                        <Form.Control
                            ref={uploadFolderRef}
                            defaultValue={bond.id}
                            isInvalid={!isFolderValid}
                            placeholder="[a-zA-Z0-9_]+ only"
                            onChange={(e) => {
                                setIsFolderValid(/^[a-zA-Z0-9_]+$/.test(e.target.value));
                            }}
                            pattern="[a-zA-Z0-9_]+"
                        />
                    </InputGroup>
                    <Button variant="primary" onClick={startUpload} disabled={uploadStarted || !(uploadFile)}
                            className={"w-100"}>
                        Upload
                        {uploadStarted ? <FontAwesomeIcon icon={faSpinner} className="ms-2 fa-spin"/> : ""}
                    </Button>

                </Form.Group>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    </>);
}

export default Upload;
